import useReveal from '@/hooks/useReveal';

export default function InnovationStatement() {
  const { ref, visible } = useReveal();

  return (
    <section className="relative w-full bg-background-100">
      <div
        ref={ref}
        className={`reveal ${visible ? 'visible' : ''} w-full max-w-[680px] mx-auto py-32 md:py-36 lg:py-[160px] px-6 md:px-10 text-center`}
      >
        <h2 className="font-body text-[32px] sm:text-[38px] md:text-[44px] font-bold leading-[1.2] text-foreground-950 mb-8">
          Continuous Innovation & Technical Excellence
        </h2>
        <p className="text-[16px] sm:text-[17px] md:text-[18px] font-body font-normal leading-[1.75] text-foreground-700 mb-12">
          We continuously refine internal processes and adopt modern engineering practices. By exploring emerging technologies and evolving development workflows, we ensure every project benefits from the most effective approaches available, delivering solutions that remain technically sound and future-ready.
        </p>
        <div className="w-[10px] h-[10px] bg-foreground-900 mx-auto" />
      </div>
    </section>
  );
}